
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/book-now",
      function () {
        return require("private-next-pages/book-now.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/book-now"])
      });
    }
  